import { Delete, Get, Patch, Post } from "./apiHelper";
import {
  ILeaveApplication,
  LeaveApplicationFormData
} from "../interfaces/LeaveApplicationInterface";

const leaveApplicationRoot = "/api/leaveApplication";

interface ResponseType<T> {
  success: boolean;
  message: string;
  data: T;
}

// post application
export async function postLeaveApplication(
  data: LeaveApplicationFormData
): Promise<ResponseType<ILeaveApplication>> {
  const response = await Post(
    `${leaveApplicationRoot}`,
    data as unknown as Record<string, unknown>,
    true
  );
  return response.data as ResponseType<ILeaveApplication>;
}

// get application
export async function getLeaveApplications({
  employeeIds,
  serviceProviderIds,
  fromDate,
  untilDate
}: {
  employeeIds?: number[];
  serviceProviderIds?: number[];
  date?: string;
  fromDate?: string;
  untilDate?: string;
}): Promise<ResponseType<Array<ILeaveApplication>>> {
  const queryParams = new URLSearchParams();

  if (fromDate) {
    queryParams.append("fromDate", fromDate);
  }
  if (untilDate) {
    queryParams.append("untilDate", untilDate);
  }

  if (employeeIds && employeeIds.length > 0) {
    queryParams.append("employeeIds", employeeIds.join(","));
  }
  if (serviceProviderIds && serviceProviderIds.length > 0) {
    queryParams.append("serviceProviderIds", serviceProviderIds.join(","));
  }

  const url = `${leaveApplicationRoot}/?${queryParams.toString()}`;

  const response = await Get(url, true);
  return response.data as ResponseType<Array<ILeaveApplication>>;
}

// patch application
export async function patchLeaveApplication({
  id,
  data
}: {
  id: number | string;
  data: unknown;
}): Promise<ResponseType<ILeaveApplication>> {
  const response = await Patch(
    `${leaveApplicationRoot}/${id}`,
    data as unknown as Record<string, unknown>,
    true
  );
  return response.data as ResponseType<ILeaveApplication>;
}

// approve application
export async function approveLeaveApplication({
  id,
  decisionDate,
  decisionBy
}: {
  id: number;
  decisionDate: Date;
  decisionBy: string;
}): Promise<ResponseType<ILeaveApplication>> {
  const response = await Patch(
    `${leaveApplicationRoot}/${id}/approve`,
    { decisionBy, decisionDate },
    true
  );
  return response.data as ResponseType<ILeaveApplication>;
}

// reject application
export async function rejectLeaveApplication({
  id,
  decisionDate,
  decisionBy
}: {
  id: number;
  decisionDate: Date;
  decisionBy: string;
}): Promise<ResponseType<ILeaveApplication>> {
  const response = await Patch(
    `${leaveApplicationRoot}/${id}/reject`,
    { decisionBy, decisionDate },
    true
  );
  return response.data as ResponseType<ILeaveApplication>;
}

// delete application
export async function deleteLeaveApplication(id: number | string): Promise<ResponseType<null>> {
  const response = await Delete(`${leaveApplicationRoot}/${id}`, true);
  return response.data as ResponseType<null>;
}

// get application of employee or service provider
export async function getLeaveApplicationsByUserId({
  rcId,
  userId,
  authenticable
}: {
  rcId: number;
  userId: number;
  authenticable: string;
}): Promise<ResponseType<Array<ILeaveApplication>>> {
  const query = new URLSearchParams({
    rcId: rcId.toString(),
    authenticable
  });

  const url = `/api/users/${userId}/leaveApplication?${query.toString()}`;

  const response = await Get(url, true);
  return response.data as ResponseType<Array<ILeaveApplication>>;
}
